// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"cb03d50d","581":"6253719e","766":"7464ec14"}[chunkId] + ".chunk.js";
};